import r,{SwitchCaseJsonMapper as e}from"jsona";var o=new r({jsonPropertiesMapper:new e({switchChar:"_"})});export{o as jsonaDataFormatter};
